/* eslint-disable react-hooks/exhaustive-deps */
"use client";

import { GeneralPropsType } from "@/common/types";
import { createContext, useContext, useEffect, useState } from "react";

// import toast, { Toaster } from "react-hot-toast";
import toast, { Toaster, toast as toastHandler, useToasterStore } from "react-hot-toast";
const MAX_NOTIFICATIONS = 5;
const toastList: any = [];
export const NotifyContext = createContext<{
  success: Function;
  error: Function;
  info: Function;
} | null>(null);
const duration = 10000;
function NotifyProvider({
  children
}: GeneralPropsType) {
  const {
    toasts,
    pausedAt
  } = useToasterStore();
  const limitNotify = () => {
    if (toasts.length >= MAX_NOTIFICATIONS) {
      const oldestToast = toasts[toasts.length - 1]?.id;
      if (oldestToast) {
        toast.remove(oldestToast); // Dismiss the oldest toast
      }
    }
  };
  const success = (message: string, config: any) => {
    toast.success(<span className="not_apply_adjust_color_tbk">{message}</span>, {
      duration,
      style: {
        backgroundColor: "#000"
      },
      className: "!text-primary !rounded-2xl",
      ...config
    });
    limitNotify();
  };
  const error = (message: string, config: any, customDuration?: number) => {
    toast.error(<span className="not_apply_adjust_color_tbk">{message}</span>, {
      duration,
      style: {
        backgroundColor: "#000"
      },
      className: "!text-error !rounded-2xl",
      ...config
    });
    limitNotify();
  };
  const info = (message: string, config: any) => {
    toast(<span className="not_apply_adjust_color_tbk">{message}</span>, {
      duration,
      icon: <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.09475 14.1308C9.29375 14.1308 9.46233 14.0634 9.6005 13.9288C9.73867 13.7941 9.80775 13.6273 9.80775 13.4283C9.80775 13.2293 9.74042 13.0607 9.60575 12.9225C9.47108 12.7845 9.30425 12.7155 9.10525 12.7155C8.90625 12.7155 8.73767 12.7828 8.5995 12.9173C8.46133 13.0519 8.39225 13.2188 8.39225 13.4178C8.39225 13.6168 8.45958 13.7853 8.59425 13.9235C8.72892 14.0617 8.89575 14.1308 9.09475 14.1308ZM8.45 10.877H9.75V4.877H8.45V10.877ZM9.1085 18.7C7.85667 18.7 6.67767 18.4632 5.5715 17.9895C4.46533 17.5158 3.49717 16.8641 2.667 16.0343C1.83683 15.2044 1.18475 14.237 0.71075 13.132C0.236917 12.0272 0 10.8466 0 9.59025C0 8.33392 0.236833 7.15683 0.7105 6.059C1.18417 4.96117 1.83592 3.99717 2.66575 3.167C3.49558 2.33683 4.463 1.68475 5.568 1.21075C6.67283 0.736917 7.85342 0.5 9.10975 0.5C10.3661 0.5 11.5432 0.736833 12.641 1.2105C13.7388 1.68417 14.7028 2.33592 15.533 3.16575C16.3632 3.99558 17.0153 4.961 17.4893 6.062C17.9631 7.16317 18.2 8.33967 18.2 9.5915C18.2 10.8433 17.9632 12.0223 17.4895 13.1285C17.0158 14.2347 16.3641 15.2028 15.5343 16.033C14.7044 16.8632 13.739 17.5153 12.638 17.9893C11.5368 18.4631 10.3603 18.7 9.1085 18.7ZM9.1 17.4C11.2667 17.4 13.1083 16.6417 14.625 15.125C16.1417 13.6083 16.9 11.7667 16.9 9.6C16.9 7.43333 16.1417 5.59167 14.625 4.075C13.1083 2.55833 11.2667 1.8 9.1 1.8C6.93333 1.8 5.09167 2.55833 3.575 4.075C2.05833 5.59167 1.3 7.43333 1.3 9.6C1.3 11.7667 2.05833 13.6083 3.575 15.125C5.09167 16.6417 6.93333 17.4 9.1 17.4Z" fill="#01FFFF" />
                </svg>,
      style: {
        backgroundColor: "#000"
      },
      className: "!text-secondary !rounded-2xl",
      ...config
    });
    limitNotify();
  };
  return <NotifyContext.Provider value={{
    success,
    error,
    info
  }} data-sentry-element="unknown" data-sentry-component="NotifyProvider" data-sentry-source-file="index.tsx">
            {children}
            <Toaster data-sentry-element="Toaster" data-sentry-source-file="index.tsx" />
        </NotifyContext.Provider>;
}
export default NotifyProvider;
export const useNotify = () => {
  const context = useContext(NotifyContext);
  return context;
};